// @flow
import type { Car } from '../types';
import * as constants from '../constants/carConstants';

type SetCarAction = {|
    type: typeof constants.SET,
    data: Car
|};

type UnsetCarAction = {|
    type: typeof constants.UNSET,
    data: Car
|};

type SetCarsAction = {|
    type: typeof constants.BATCH_SET,
    data: $ReadOnly<{[icao: string]: $ReadOnlyArray<Car>}>
|};

type EndCarSessionAction = {|
    type: typeof constants.END_SESSION,
    data: string
|};

export type CarAction = SetCarAction | UnsetCarAction | SetCarsAction | EndCarSessionAction;


export default {
    setCar: (car: Car): SetCarAction => ({
        type: constants.SET,
        data: car
    }),
    unsetCar: (car: Car): UnsetCarAction => ({
        type: constants.UNSET,
        data: car
    }),
    setCars: (cars: $ReadOnly<{[icao: string]: $ReadOnlyArray<Car>}>): SetCarsAction => ({
        type: constants.BATCH_SET,
        data: cars
    }),
    endSession: (icao: string): EndCarSessionAction => ({
        type: constants.END_SESSION,
        data: icao
    })
};